import {debounce, uniqueId} from "lodash";

export default {
	template: `
		<div class="swipe-container" :id="id" :style="styles">
		<slot :prev="prev" :next="next" :controls="controls"></slot>
		</div>`,
	props: {
		scrollLeft: {
			type: Number
		}
	},
	data() {
		return {
			id: "inrt-" + uniqueId(),
			styles: {
				overflow: "hidden",
			},
			slides: [],
			slider: {},
			controls: {
				prev: {
					hidden: true,
					disabled: true
				},
				next: {
					hidden: true,
					disabled: true
				}
			},
			debounceTimeout: 100,
			slideChangeTimeout: 300
		}
	},
	components: {},
	computed: {},
	methods: {
		prev() {
			let containerRect = this.slider.getBoundingClientRect();

			let slideToScroll = this.slides.slice().reverse().find(slide => {
				let slideRect = slide.getBoundingClientRect();
				return (slideRect.left < containerRect.left) ? true : false;
			});

			if (slideToScroll) $(this.slider).animate({scrollLeft: slideToScroll.offsetLeft}, this.slideChangeTimeout);
		},
		next() {
			let containerRect = this.slider.getBoundingClientRect();

			let slideToScroll = this.slides.find(slide => {
				let slideRect = slide.getBoundingClientRect();
				return (Math.floor(slideRect.right) > Math.floor(containerRect.right)) ? true : false;
			});
			if (slideToScroll) $(this.slider).animate({scrollLeft: slideToScroll.offsetLeft - (this.slider.offsetWidth - slideToScroll.offsetWidth)}, this.slideChangeTimeout);
		},
		init() {
			new inrt.scroller({elementId: this.id});
			window.addEventListener("resize", debounce(this.checkControls.bind(this), this.debounceTimeout));
			this.slider.addEventListener("scroll", debounce(this.scrollCheck.bind(this)));
			this.slider.addEventListener("scroll", (e) => this.$emit("swipe-container-scroll", {
				scroll: this.slider.scrollLeft,
				event: e
			}));
			this.dragFix();
			this.checkControls();
		},
		scrollCheck() {
			let lastSlide = this.slides[this.slides.length - 1];
			if (this.slider.scrollLeft === 0) {
				this.controls.prev.disabled = true;
			} else if ((lastSlide.offsetLeft + lastSlide.offsetWidth - this.slider.offsetWidth) === this.slider.scrollLeft) {
				this.controls.next.disabled = true;
			} else {
				this.enableControls();
			}
		},
		enableControls() {
			Object.values(this.controls).forEach(control => {
				control.hidden = false;
				control.disabled = false;
			});
		},
		hideControls() {
			Object.values(this.controls).forEach(control => control.hidden = true);
		},
		checkControls() {
			const slidesWidth = this.slides.reduce((a, slide) => a + slide.offsetWidth, 0);
			if (slidesWidth > this.slider.offsetWidth) {
				this.enableControls();
				this.controls.prev.disabled = true;
			} else {
				this.hideControls();
			}
		},
		dragFix() {
			var flagdrag = false,
				flagdown = false,
				timeout;
			$(this.$el).on({
				mousemove: function (e) {
					if (flagdown) flagdrag = true;
					if (flagdrag) {
						$(this).find('a').css({
							'pointer-events': 'none'
						});
					}
				},
				mousedown: function (e) {
					e.preventDefault();
					timeout = setTimeout(function () {
						flagdown = true;
					}, 100);
				},
				mouseup: function (e) {
					clearTimeout(timeout);
					flagdown = false;
					flagdrag = false;
					$(this).find('a').removeAttr('style');
				}
			});
		},
		refresh() {
			this.slider = this.$el;
			this.slides = [...this.$el.querySelector("[data-swipe-container]").children];
			this.checkControls();
		},
		setScroll(scroll) {
			this.slider.scrollLeft = scroll;
		}
	},
	watch: {
		scrollLeft(val) {
			this.slider.scrollLeft = val;
		}
	},
	mounted() {
		this.slider = this.$el;
		this.slides = [...this.$el.querySelector("[data-swipe-container]").children];
		this.init();
	},
	created() {
	}
}
